import { createUrlStore } from '@terminal/utils/url-store/urlStore';

export type NewsFiltersMapping = Record<string, string[]>;

export type NewsUrlState = {
  newsFilters: NewsFiltersMapping;
  newsMostRead: '1' | '0' | '';
  aOMostReadNews: '1' | '0' | '';
  dateRangeEnd?: string;
  setMostReadParam: (value: boolean) => void;
  setAOMostReadNews: (value: boolean) => void;
  setUrlFilters: (value: NewsFiltersMapping) => void;
  setDateRangeEnd: (value?: string) => void;
  resetAll: () => void;
};

const { useParamStore } = createUrlStore<NewsUrlState>((set, _get) => ({
  newsFilters: {},
  newsMostRead: '1',
  aOMostReadNews: '0',
  dateRangeEnd: undefined,
  setMostReadParam: value => set({ newsMostRead: value ? '1' : '0' }),
  setAOMostReadNews: value => set({ aOMostReadNews: value ? '1' : '0' }),
  setUrlFilters: value => set({ newsFilters: value }),
  setDateRangeEnd: value => set({ dateRangeEnd: value }),
  resetAll: () =>
    set({ newsFilters: {}, newsMostRead: '1', dateRangeEnd: undefined }),
}));

export const useNewsUrlStore = useParamStore;
